import { useIntl } from 'react-intl';
import { getColumns } from './columns';
import CustomTypeControlList from '../../components/CustomTypeControlList';
import { getConcreteClasses100 } from '../../../../../services/redux/concreteClasses100/actions';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { MainContext } from '../../../../../context/MainContext';
import { NotificationsContext } from '../../../../../context/NotificationsContext';
import useNormativeApi from '../../components/CustomTraceabilityList/components/EditModal/hooks/useNormativeApi';

const C100ControlList = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { setLoading } = useContext(MainContext);
  const { pushNotification } = useContext(NotificationsContext);
  const { updateDataScript } = useNormativeApi();

  return (
    <CustomTypeControlList
      columns={getColumns(intl)}
      entity="concreteClasses100"
      normative="ehe"
      title={intl.formatMessage({
        id: 'pages.quality.normative.100Control.list.title',
      })}
      action={getConcreteClasses100}
      onView={(item) => {
        // Obtener el primer batch que tenga delivery_note_data
        const firstBatch = item.concrete_batch_data?.find(
          (batch) => batch.delivery_note_data && batch.delivery_note_data.length > 0
        );

        if (firstBatch) {
          localStorage.setItem('Lote', firstBatch.batch_code.toString());
          localStorage.setItem(
            'CBID',
            firstBatch.delivery_note_data[0].concrete_batch.toString(),
          );
          setLoading(true);
          updateDataScript(
            true,
            firstBatch.delivery_note_data[0].id,
            firstBatch.delivery_note_data[0].concrete_batch,
            firstBatch.delivery_note_data[0].concrete_batch,
          )
            .then(() => {
              pushNotification({
                message: intl.formatMessage({
                  id: 'pages.quality.normative.statistical-control.lotting.list.success.updatingDataScript',
                }),
                type: 'success',
              });
              navigate(`${item.name}`);
            })
            .catch(() => {
              setLoading(false);
              pushNotification({
                message: intl.formatMessage({
                  id: 'pages.quality.normative.statistical-control.lotting.list.error.updatingDataScript',
                }),
                type: 'error',
              });
            })
            .finally(() => {
              setLoading(false);
            });
        } else {
          navigate(`${item.name}`);
        }
      }}
      customDataParseFunction={(items) => {
        return items.map((item) => {
          const hasNc = item.concrete_batch_data.some(
            (batch) => batch.non_conformity !== null,
          );
          return {
            ...item,
            nc: hasNc
              ? intl.formatMessage({ id: 'yes' }).toUpperCase()
              : undefined,
          };
        });
      }}
    />
  );
};

export default C100ControlList;
